import {
  ThreeStars,
  ShoppingBag,
  Controller,
  GraduationHat,
  RedCross,
  IndustrialPlant,
  CityRoad,
  Highway,
  Railway,
  Bridge,
  GovernmentBuilding,
} from './icons';

export const typeFilters = {
  'tien-ich': [
    {
      id: 'tien-ich-chinh',
      icon: ThreeStars,
      label: 'Các tiện ích chính',
    },
    {
      id: 'co-quan-hanh-chinh',
      icon: GovernmentBuilding,
      label: 'Cơ quan hành chính',
    },
    {
      id: 'trung-tam-thuong-mai',
      icon: ShoppingBag,
      label: 'Trung tâm thương mại',
    },
    {
      id: 'truong-hoc',
      icon: GraduationHat,
      label: 'Trường học',
    },
    { id: 'benh-vien', icon: RedCross, label: 'Bệnh viện' },
    {
      id: 'vui-choi-giai-tri',
      icon: Controller,
      label: 'Vui chơi giải trí',
    },
    { id: 'khu-cong-nghiep', icon: IndustrialPlant, label: 'Khu công nghiệp' },
  ],
  'giao-thong': [
    {
      id: 'truc-do-thi',
      icon: CityRoad,
      label: 'Trục đô thị',
    },
    {
      id: 'duong-cao-toc',
      icon: Highway,
      label: 'Đường cao tốc',
    },
    { id: 'duong-sat-do-thi', icon: Railway, label: 'Đường sắt đô thị' },
    { id: 'cau-hien-tai', icon: Bridge, label: 'Cầu hiện tại' },
    { id: 'cau-tuong-lai', icon: Bridge, label: 'Cầu tương lai' },
  ],
};

export const types = [
  {
    id: 'tien-ich',
    label: 'Tất cả tiện ích',
    labelShort: 'Tiện ích',
  },
  {
    id: 'giao-thong',
    label: 'Tất cả giao thông',
    labelShort: 'Giao thông',
  },
];
